<template>
  <div class="banner">
    <el-carousel class="carousel" trigger="click" height="490px" arrow="never">
      <el-carousel-item v-for="item in banners" :key="item">
        <img class="bannerImg" :src="item" />
      </el-carousel-item>
    </el-carousel>
  </div>
</template>

<script>
export default {
  name: "TopCarousel",
  props: {
    banners: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {};
  },
};
</script>

<style scoped>
.banner {
  min-width: var(--content-min-width);
}
.banner .bannerImg {
  width: 100%;
  height: 100%;
}
.banner >>> .el-carousel__indicators--horizontal {
  left: calc((100% - var(--content-width)) / 2);
  bottom: 58px;
  transform: translateX(0%);
  padding-left: 20px;
  padding-right: 12px;
}
.banner >>> .el-carousel__indicators--horizontal:hover {
  left: calc((100% - var(--content-width)) / 2);
  bottom: 58px;
  transform: translateX(0%);
  padding-left: 20px;
  padding-right: 12px;
  background-color: rgba(0, 0, 0, 0.2);
}
.banner >>> .el-carousel__indicators--horizontal .el-carousel__button {
  width: 16px;
  height: 6px;
}
.banner >>> .el-carousel__indicators--horizontal .is-active .el-carousel__button {
  background-color: #398fff; /* 选中指示器的颜色 */
  width: 40px;
  height: 6px;
}

/* 箭头 */
/* .carousel >>> .el-carousel__arrow {
  color: #999999;
  background-color: rgba(0, 0, 0, 0.2);
  width: 32px;
  height: 30px;
  line-height: 30px;
  font-size: 16px;
  border-radius: 0;
  top: auto !important;
  bottom: 42px;
}
.carousel >>> .el-carousel__arrow--left:hover,
.carousel >>> .el-carousel__arrow--right:hover {
  color: #fff;
}
.carousel >>> .el-carousel__arrow--left {
  left: auto;
  right: calc((100% - var(--content-width)) / 2);
  margin-right: 32px;
}
.carousel >>> .el-carousel__arrow--right {
  right: calc((100% - var(--content-width)) / 2);
} */
</style>



// WEBPACK FOOTER //
// src/components/TopCarousel.vue